/** The statuses a scan's absence can contradict. */
const CONTRADICTABLE = new Set(['live', 'apply-failed']);
/**
 * Whether the kept inventory says an instance is gone.
 *
 * Only when that scan is newer than `lastTouched` — the instance's newest run,
 * or its adoption. A run after the scan is newer evidence than the scan, and a
 * prompt contradicting it would be the stale cache overruling the record.
 *
 * `unknown` counts as present: a cluster the scan could not classify is not a
 * cluster it proved absent, and this is only ever allowed to err towards
 * leaving a live instance alone.
 */
export const scanSaysGone = (inventory, deploymentId, lastTouched) => {
    if (inventory === undefined || inventory.scannedAt <= lastTouched)
        return undefined;
    const rows = inventory.instances.filter((e) => e.deploymentId === deploymentId);
    if (rows.length === 0)
        return undefined;
    const present = rows.filter((e) => e.goneSince === undefined);
    if (present.some((e) => e.state !== 'residue'))
        return undefined;
    const since = rows
        .map((e) => e.goneSince)
        .filter((at) => at !== undefined)
        .sort()[0];
    return {
        scannedAt: inventory.scannedAt,
        evidence: present.length > 0 ? 'storage-only' : 'nothing-found',
        ...(since === undefined ? {} : { since }),
    };
};
/**
 * Whether a status is one the scan's absence may prompt about.
 *
 * `in-progress` is left alone — the run will say — and `destroyed` and
 * `never-applied` already describe nothing being there.
 */
export const canBeGoneOutside = (status) => CONTRADICTABLE.has(status);
/** The words for the evidence, shared by the console and the audit trail. */
export const describeOutsideEvidence = (evidence) => evidence === 'storage-only'
    ? 'no cluster, only leftover storage'
    : 'nothing at all for this deployment id';
//# sourceMappingURL=outside.js.map